import axiosClient from "utils/api";
const URI = "admin/auth";

export const loginAdmin = async (payload) => {
  const URL = `${URI}/login`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during login:", error);
    throw error;
  }
};

export const logOutAdmin = async () => {
  const URL = `${URI}/logout`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Logout:", error);
    throw error;
  }
};

export const forgotPassword = async (payload) => {
  const URL = `${URI}/forgotPassword`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Change Password:", error);
    throw error;
  }
};

export const resetPassword = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/resetPassword/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Change Password:", error);
    throw error;
  }
};
